angular.module("Main").controller("kursplanNichtBuchbarDialogController", ["$rootScope", "$scope", "$location", "$state", "$cookies", "$uibModal", "$uibModalInstance", "AuthenticationService", "BookingService", "data",
    function ($rootScope, $scope, $location, $state, $cookies, $uibModal, $uibModalInstance, AuthenticationService, BookingService, data) {
        var vm = this;
        vm.reason = data.reason

    }]);